<template>
  <div class="pointer">
        <v-btn v-if="currentPage > 1" small elevation="1" class="pagingBtn mr-3" @click="onPageChange(currentPage - 1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn v-if="currentPage == 1" small elevation="1" class="pagingBtn inactives mr-3"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn text small elevation="1" v-for="(paging, index) in pages" :key="index" @click="onPageChange(paging)" :class="paging === currentPage ? 'pagingBtn curPage ml-1 mr-1' : ' pagingBtn ml-1 mr-1'">&nbsp;&nbsp;{{paging}}&nbsp;&nbsp;</v-btn>
        <v-btn v-if="currentPage < totalPages" small elevation="1" class="pagingBtn ml-3" @click="onPageChange(currentPage + 1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
        <v-btn v-if="currentPage == totalPages" small elevation="1" class="pagingBtn inactives ml-3"><v-icon>mdi-chevron-right</v-icon></v-btn>
    </div>
</template>

<style scoped>
.pointer { cursor:pointer; text-align:center;}
.curPage { color:#fff !important; background-color: #696CFF !important;}
.pagingBtn {min-width:34px !important; width:34px !important; min-height:34px !important; height:34px !important; color:#697a8d; background-color:#e1e4e8 ; font-size:14px !important;font-weight:500 !important;}
.inactives { color:#ACACAC}
</style>
<script> 
  export default {
    name: 'Paging', 
    props: {currentPage: Number,totalPages: Number,totalCount:Number},
    data() {
      return {  
        pagePerBlock: 10, listPerPage: 10,
        currentBlock: 1,
        startPage: 1, endPage: 1, pages:[], chkPage:1,
      };
    },

    created() {
      this.calPages();
    },

    methods: {

      calPages() {
        //console.log("currentPage:"+this.currentPage);
  
        this.currentBlock = Math.ceil(this.chkPage / this.listPerPage);
        //console.log("currentBlock:"+this.currentBlock);
        
        this.startPage =  (this.currentBlock - 1) * this.listPerPage + 1;
      
        let lastPage = this.startPage + this.pagePerBlock - 1;
        //console.log("lastPage="+lastPage);
        
        if (lastPage >= this.totalPages) lastPage = this.totalPages;

        this.endPage = lastPage;

        //console.log("start: "+this.startPage +" | end :"+ this.endPage);
        
        let list = [];
        for (let index = this.startPage; index <= this.endPage; index += 1) { list.push(index); }
        this.pages = list;
        //console.log("PageList:"+ list);
      },
      
      onPageChange(val) {
        if (val < 1) {
          return;
        } else if (val > this.totalPages) {
          return;
        } else {
          //console.log('chk');
          this.chkPage = val;
          this.$emit("onPageChange", val);
          this.calPages();
        }
          
      }
    }
  }
</script>